import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { 
    assetFamilyMaster, 
    columnsTemplateCheckList, 
    FaultAssetMapMaster, 
    TemplateMasterKey 
} from "../../types/assetTypes";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { 
    getFamilyAssetMasterDataList, 
    getTemplateDataById, 
    getTemplateDataList, 
    saveServiceTemplate,
    saveServiceTemplateMapping
} from "../../api/Services/masterServie";
import { enqueueSnackbar } from "notistack";
import { CustomMessage } from "../../const/Spinner";
import { getUniqueAssetNamesByFamilyId } from "../../api/Services/assetServices";
import { Checkbox, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Grid, Card, SelectChangeEvent } from "@mui/material";
import { DropdownChangeEvent } from "primereact/dropdown";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import ImagePreview from "../../Component/ImagePreview";
import { RootState } from "../../store/Reduxstore";

interface CreateFaultProps {
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  selectedMapData: FaultAssetMapMaster;
  setSelectedMapData: Dispatch<SetStateAction<FaultAssetMapMaster>>;
  isEdit: boolean; // <-- missing piece
  setIsEdit?: Dispatch<SetStateAction<boolean>>; // optional, if child can switch modes
}

const CreateFaultAssetMapping: React.FC<CreateFaultProps> = ({
  setOpen,
  selectedMapData,
  setSelectedMapData,
  isEdit,
  setIsEdit
   }) => {
    
    
    const dispatch = useDispatch();
    const [faultAssetMapData, setFaultAssetMapData] = useState<FaultAssetMapMaster>(selectedMapData
        //     {
        //     assetName: "",
        //     familyAssetId: 0,
        //     familyName: "",
        //     serviceAssetMapId: 0,
        //     serviceTemplateId: 0,
        //     serviceTemplateName: ""
        // }
        );
        console.log("Data:", selectedMapData);
        const isEditMode = Boolean(faultAssetMapData?.serviceAssetMapId); // or use another indicator

        console.log("Data:", selectedMapData);
        useEffect(()=>{
            if(selectedMapData.serviceAssetMapId !=0){
                console.log(">>");
                getTemplateList(selectedMapData.familyAssetId);
            }
        },[selectedMapData])
    
        useEffect(()=>{
            if(selectedMapData.assetName !== "") {
                console.log(">>");
                getAssetNameList(selectedMapData.familyAssetId);
            }
        },[selectedMapData])
    
        useEffect(()=>{
            if(selectedMapData.serviceTemplateId !=0){
                console.log(">>");
                getTemplateById(selectedMapData.serviceTemplateId);
            }
        },[selectedMapData])

        
    

    const [selectedData, setSelectedData] = useState<columnsTemplateCheckList[]>([]);
    const [familyTemplateData, setFamilyTemplateData] = useState<TemplateMasterKey[]>([]);
    const [familyAsset, setFamilyAsset] = useState<assetFamilyMaster[]>([]);
    const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]);

    useEffect(() => {
        if (familyAsset.length === 0) getFamilyAssetList(1,PAGESEND);
    }, [familyAsset]);

    const getFamilyAssetList = async (page: number, rows: number) => {
        dispatch(setLoading(true));
        try {
            const { data, status } = await getFamilyAssetMasterDataList(page, rows, { familyAssetId: { value: "", matchMode: "startWith" } });
            if (status.code === 200 && data?.length > 0) {
                setFamilyAsset(data);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const getTemplateList = async (familyAssetId: number) => {
        dispatch(setLoading(true));
        try {
            const response = await getTemplateDataList(familyAssetId);
            const { data, status } = response;
            if (status.code === 200 && data?.length > 0) {
                setFamilyTemplateData(data);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const getTemplateById = async (serviceTemplateId: number) => {
        dispatch(setLoading(true));
        try {
            const response = await getTemplateDataById(serviceTemplateId);
            const { data, status } = response;
            if (status.code === 200 && data && data?.columns?.length > 0) {
                setSelectedData(data.columns);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const getAssetNameList = async (familyAssetId: number) => {
        dispatch(setLoading(true));
        try {
            const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
            if (status.code === 200 && Array.isArray(data) && data.length > 0) {
                const updatedData = data.map((assetName: string) => ({
                    value: assetName,
                    label: assetName,
                }));
                updatedData.unshift({ label: "--Select--", value: "" });
                setAssetNameList(updatedData);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleSelectAssetNameChange = (e: SelectChangeEvent<any>) => {
        const selectedValues = e.target.value; // array of selected values (e.g., ['Pump', 'Valve'])
        const updatedData = { ...faultAssetMapData, assetName: selectedValues };
        setFaultAssetMapData(updatedData);
     };
      

    console.log(faultAssetMapData,'faultAssetMapData');

        const handleClear = () => {        
            setFaultAssetMapData({
                assetName: "",
                familyAssetId: 0,
                familyName: "",
                serviceAssetMapId: 0,
                serviceTemplateId: 0,
                serviceTemplateName: ""
            }); 
            setSelectedData([]);  
            console.log(faultAssetMapData);
            setOpen(false);            
        }
    
        console.log(setFaultAssetMapData,'setFaultAssetMapData');
        const handleSave = async () => {
            if(!faultAssetMapData) return;
            if (!faultAssetMapData.familyAssetId || faultAssetMapData.familyAssetId === 0) {
                CustomMessage("Please select a Family Asset.", "error", enqueueSnackbar);
                return;
            }
            if (!faultAssetMapData.serviceTemplateId || faultAssetMapData.serviceTemplateId === 0) {
                CustomMessage("Please select a Service Template.", "error", enqueueSnackbar);
                return;
            }
            if (!faultAssetMapData.assetName || faultAssetMapData.assetName === "") {
                CustomMessage("Please select a Asset Name.", "error", enqueueSnackbar);
                return; 
            }
            dispatch(setLoading(true));
            try{
                const response = await saveServiceTemplateMapping(faultAssetMapData);
                const {data,status} = response;
                if(status.code === 200 || status.code === 201){
                    handleClear();
                    CustomMessage(status.message,'success',enqueueSnackbar);
                }else{
                    CustomMessage(status.message,'error',enqueueSnackbar);
                }
            }catch(error:any){
                CustomMessage(error.message,'error',enqueueSnackbar);
            }finally{    
                dispatch(setLoading(false));
            }
        }
    const serviceTypes = Array.from(
    new Set(
        selectedData.flatMap((col) =>
            col.serviceTypeStatuses.map((status) => status.serviceTypeName)
        )
    )
   );
    const userDetails = useSelector((state: RootState) => state.auth)

    return (
        <Box p={0}>           

            <Card elevation={3} sx={{ p: 3, borderRadius: 2, background: "#f9f9f9" }}>
                <Grid container spacing={3}>
                    {/* Family Asset Dropdown */}
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth>
                            <h6 className="mb-1">Select Family</h6>
                            <Select
                                value={faultAssetMapData.familyAssetId}
                                style={{ background: "#fff" }}
                                onChange={(e) => {
                                    getTemplateList(e.target.value as number);
                                    getAssetNameList(e.target.value as number);
                                    setFaultAssetMapData({ ...faultAssetMapData, familyAssetId: e.target.value as number });
                                }}
                            >
                                {familyAsset.map((asset) => (
                                    <MenuItem key={asset.familyAssetId} value={asset.familyAssetId}>
                                        {asset.familyName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Template Dropdown */}
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth>
                            <h6 className="mb-1">Select Template</h6>
                            <Select
                                value={faultAssetMapData.serviceTemplateId}
                                style={{ background: "#fff" }}
                                onChange={(e) => {
                                    getTemplateById(e.target.value as number);
                                    setFaultAssetMapData({ ...faultAssetMapData, serviceTemplateId: e.target.value as number });
                                }}
                            >
                                {familyTemplateData.map((template) => (
                                    <MenuItem key={template.serviceTemplateId} value={template.serviceTemplateId}>
                                        {template.serviceTemplateName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth variant="outlined" style={{ borderRadius: 5 }}>
                    <h6 className="mb-1">Asset Types</h6>
                    <Select
                        multiple={!isEditMode}
                        value={faultAssetMapData.assetName || []}
                        onChange={handleSelectAssetNameChange}
                        displayEmpty
                        style={{ background: "#fff" }}
                        renderValue={(selected: any) => {
                            if (!Array.isArray(selected)) {
                              // single value for edit
                              return selected || "Select Asset Types";
                            }
                          
                            // multiple values for create
                            return selected.length === 0
                              ? "Select Asset Types"
                              : selected.join(", ");
                          }}
                          
                    >
                        <MenuItem disabled value="">
                        Select Asset Types
                        </MenuItem>
                        {assetName.map((type) => (
                        <MenuItem key={type.value} value={type.value}>
                            {type.label}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                    </Grid>

                </Grid>
            </Card>

            {/* Table */}
            {selectedData.length > 0 && (
                <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 3, borderRadius: 2 }}>
                    <Table>

                         <TableHead sx={{ background: "#e0e0e0" }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: "bold" }}>Column Name</TableCell>
                                                        {serviceTypes.map((type) => (
                                                            <TableCell key={type} sx={{ fontWeight: "bold" }}>
                                                                {type}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {selectedData.map((col, i) => {
                                                        const attachment = col.attachments?.[0] || null;
                                                        const typeStatusMap = new Map(
                                                            col.serviceTypeStatuses.map((status) => [status.serviceTypeName, status.isChecked])
                                                        );
                        
                                                        return (
                                                            <TableRow
                                                                key={i}
                                                                sx={{ backgroundColor: i % 2 ? "#f5f5f5" : "#fff" }}
                                                            >
                                                                <TableCell sx={{ fontWeight: "bold", width: "300px" }}>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "12px",
                                                                    }}>
                                                                        <div
                                                                            style={{
                                                                                width: "59px",
                                                                                height: "59px",
                                                                                borderRadius: "50%",
                                                                                border: "1px solid #ccc",
                                                                                overflow: "hidden",
                                                                                backgroundColor: "#f5f5f5",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                flexShrink: 0,
                                                                            }}
                                                                        >
                                                                            {attachment?.attachmentId && (
                                                                                <ImagePreview
                                                                                    alt={`Attachment ${attachment.attachmentId}`}
                                                                                    src={`${FILE_DOWNLOAD_PREVIEW}${attachment.attachmentId}`}
                                                                                    style={{
                                                                                        width: "59px",
                                                                                        height: "59px",
                                                                                        borderRadius: "50%",
                                                                                        objectFit: "cover"
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <span>{col.templateColumnName}</span>
                                                                    </div>
                                                                </TableCell>
                        
                                                                {serviceTypes.map((type) => (
                                                                    <TableCell key={type}>
                                                                        <Checkbox
                                                                            checked={!!typeStatusMap.get(type)}
                                                                            color="primary"
                                                                            disabled
                                                                        />
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                        {/* <TableHead sx={{ background: "#e0e0e0" }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Column Name</TableCell>
                                {[250, 500, 1500, 2000].map((col) => (
                                    <TableCell key={col} sx={{ fontWeight: "bold" }}>{col}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead> */}
                        {/* <TableBody>
                            {selectedData.map((col, i) => (
                                <TableRow key={i} sx={{ backgroundColor: i % 2 ? "#f5f5f5" : "#fff" }}>
                                    <TableCell sx={{ fontWeight: "bold" }}>{col.templateColumnName}</TableCell>
                                    {(["column250", "column500", "column1500", "column2000"] as const).map((column, idx) => (
                                        <TableCell key={idx}>
                                            <Checkbox checked={col[column] || false} color="primary" disabled />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody> */}
                        {/* <TableBody>
                            {selectedData.map((col, i) => {
                                const attachment =
                                col.attachments && col.attachments.length > 0
                                    ? col.attachments[0]
                                    : null;

                            return (
                            <TableRow
                                key={i}
                                sx={{ backgroundColor: i % 2 ? "#f5f5f5" : "#fff" }}
                            >
                                <TableCell sx={{ fontWeight: "bold", width: "300px" }}>
                                <div
                                    style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    }}
                                >
                                   
                                    <div
                                    style={{
                                        width: "59px",
                                        height: "59px",
                                        borderRadius: "50%",
                                        border: "1px solid #ccc",
                                        overflow: "hidden",
                                        backgroundColor: "#f5f5f5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    }}
                                    >
                                    {attachment && attachment.attachmentId && (
                                        <ImagePreview
                                        alt={`Attachment ${attachment.attachmentId}`}
                                        src={`${FILE_DOWNLOAD_PREVIEW}${attachment.attachmentId}`}
                                        style={{
                                            width: "59px",
                                            height: "59px",
                                            borderRadius: "50%",
                                            objectFit: "cover"
                                          }}
                                        />
                                    )}
                                    </div>

                                    <span>{col.templateColumnName}</span>
                                </div>
                                </TableCell>

                              
                            </TableRow>
                            );
                        })}
                        </TableBody> */}


                    </Table>
                </TableContainer>
            )}
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <ReusablePrimeButton
                label="Cancel"
                onClick={handleClear}
                className="p-button-secondary btn btn-secondary text-white"
            />
            {userDetails.role.some(
                r => r.roleName === "Admin" || r.roleName === "Service Mapping Write"
                ) && (
                <ReusablePrimeButton
                    label="Save"
                    onClick={handleSave}
                    className="btn btn-primary w120 h-45"
                />
                )}

            
            </Box>
        </Box>
    );

};


export default CreateFaultAssetMapping;